module.exports = __webpack_public_path__ + "static/image1-2f418d8eff36a30048fe8233980d9129.jpg";